import error from './errors';
import fields from './fields';

export default {
  error,
  fields,
  app: {
    title: 'Apostilla'
  },
  btn: {
    next: 'Siguiente',
    prev: 'Anterior',
    cancel: 'Cancelar',
    back: 'Volver atrás',
    search: 'Buscar trámite',
    solicitar: 'Solicitar apostilla',
    finalizar: 'Finalizar',
    verificar: 'Verificar',
    register: 'Registrando...',
    solicitando: 'Solicitando...'
  },
  months: {
    enero: 'Enero',
    febrero: 'Febrero',
    marzo: 'Marzo',
    abril: 'Abril',
    mayo: 'Mayo',
    junio: 'Junio',
    julio: 'Julio',
    agosto: 'Agosto',
    septiembre: 'Septiembre',
    octubre: 'Octubre',
    noviembre: 'Noviembre',
    diciembre: 'Diciembre'
  },
  menu: {
    inicio: 'Inicio',
    paises: 'Estados',
    tramite: 'Trámites',
    solicitud: 'Solicitud',
    seguimiento: 'Seguimiento',
    verificar: 'Verificar',
    pagos: 'Registro de pago',
    contactos: 'Contactos',
    reclamos: 'Reclamos y/o Sugerencias'
  },
  inicio: {
    title: 'APOSTILLA - BOLIVIA',
    detalle: 'La Apostilla es un certificado que permite reconocer los documentos públicos bolivianos en el exterior y suprime la exigencia de legalización de documentos públicos extranjeros en el país. Puede solicitar su Apostilla a través de este sitio web o de manera presencial en las entidades miembro del sistema de emisión de Apostillas. Usted tendrá su Apostilla Digital que podrá ser verificada desde cualquier parte del mundo.',
    btnSolicitar: 'Solicitar apostilla',
    btnSeguimiento: 'Estado de mi solicitud',
    btnVerificar: 'Verificar mi apostilla',
    btnAniversario: '7 años de apostilla',
    modal: {
      title: 'IMPORTANTE',
      header: ' Para verificar la Apostilla ingresa a la página <a href="https://apostilla.rree.gob.bo" target="_blank">https://apostilla.rree.gob.bo</a>  sección <b>“VERIFICAR”</b> e ingresa los siguientes datos:',
      date: 'Fecha de emisión de la Apostilla',
      number: 'Número de la Apostilla',
      code: 'Código de seguridad',
      footer: 'Si la respuesta indica <b>“no se encontró ningún registro”</b> esa Apostilla no es válida.',
      important: '<b>Esta página es la fuente oficial de verificación de nuestra Apostilla.</b>'
    }
  },
  tramite: {
    title: 'Lista de trámites de la apostilla'
  },
  solicitud: {
    showVideo: 'Ver video tutorial de solicitud',
    video: 'Video tutorial - Solicitud',
    title: 'Formulario de solicitud de la Apostilla',
    datos_titular: `<strong>Titular del documento.-</strong> Son los datos de la persona a la cual pertenecerá el documento apostillado.`,
    comunicado: 'COMUNICADO',
    comunicado1: 'Una vez realizada la solicitud, tiene hasta <b>CINCO (5) DIAS HÁBILES PARA PRESENTARSE ANTE LA ENTIDAD EMISORA</b> responsable de emitir el documento público, caso contrario la solicitud será eliminada automáticamente del Sistema Integrado de la Apostilla.',
    comunicado2: 'Una vez atendida su solicitud por la Entidad Emisora responsable del documento público, el usuario tiene hasta quince días hábiles para presentarse ante la Cancillería Boliviana para concluir su trámite de Apostillado, caso contrario su solicitud será eliminada automáticamente del Sistema Integrado de Apostillado',
    comunicado3: 'Una vez firmado el documento por la Entidad Emisora, Cancillería <b>AUTORIZARÁ EL PAGO</b> del mismo mediante un correo electrónico, debiendo efectuarse al pago en la cuenta de Cancillería en un plazo máximo de <b>TREINTA (30) DÍAS</b>, caso contrario la solicitud será eliminada automáticamente del Sistema Integrado de la Apostilla.',
    comunicado4: 'Tome en cuenta que el procedimiento para la OBTENCIÓN DE LA APOSTILLA ES DIGITAL POR LO QUE NO REQUIERE SU PRESENCIA EN LAS OFICINAS DE LA CANCILLERÍA. Puede hacer seguimiento de su trámite a través de: <b>LA PAZ</b>: Teléfono 2408900 interno 4000 WhatsApp +591 71555087 <b>SANTA CRUZ</b>: Teléfono 3123220 WhatsApp +591 71270753 <b>COCHABAMBA</b>: Teléfono 4141427 WhatsApp +591 71555249',
    cambio: 'Los trámites de legalización <b>podrán ser pagados en dólares americanos o en bolivianos al tipo de cambio oficial del día del pago.</b>'
  },
  contacto: {
    title: 'Contactos',
    laPaz: '<b>LA PAZ:</b> Teléfono 2408900 interno 4000 - WhatsApp +591 71555087',
    santaCruz: '<b>SANTA CRUZ:</b> Teléfono 3123220 - WhatsApp +591 71270753',
    cochabamba: '<b>COCHABAMBA:</b> Teléfono 4141427 - WhatsApp +591 71555249'
  },
  seguimiento: {
    showVideo: 'Ver video tutorial de seguimiento',
    video: 'Video tutorial - Seguimiento',
    title: 'Seguimiento de su trámite'
  },
  verificar: {
    showVideo: 'Ver video tutorial de verificar',
    video: 'Video tutorial - Verificar',
    title: 'Verificar documento apostillado'
  },
  pago: {
    showVideo: 'Ver video tutorial de pago',
    video: 'Video tutorial - Registrar pago'
  },
  BUSCAR_TRAMITE: 'Buscar trámite',
  PRECIO: 'Precio',
  VER_DETALLES: 'Ver detalles',
  SOLICITAR_APOSTILLA: 'Solicitar apostilla',
  ESCRIBIR_TRAMITE: 'Escriba aquí el trámite que desea buscar',
  calidad: {
    title: 'POLÍTICA DE LA CALIDAD',
    descripcion: 'La <b>Dirección General de Apostilla, Legalizaciones y Cultos</b>, como parte del Ministerio de Relaciones Exteriores del Estado Plurinacional de Bolivia, es <b>responsable de los procesos de Apostillado y Legalización de documentos públicos en territorio nacional</b>, atendiendo los requerimientos de los usuarios en el marco de las disposiciones legales vigentes y los reglamentos internos aplicables a estos procesos. ',
    leyenda: '“La gestión de la calidad representa un pilar fundamental de la Dirección, está comprometida con el cumplimiento de sus objetivos y con la mejora continua, para brindar un servicio de excelencia”',
    codigo: 'SGC-DOC-002',
    mision: {
      title: 'MISIÓN',
      descripcion: 'La Dirección General de Apostilla, Legalizaciones y Cultos como Área Operativa Funcional del Ministerio de Relaciones Exteriores tiene como misión brindar el servicio de Apostillado y Legalización de Firmas de Documentos Públicos, en beneficio de los usuarios, buscando que éste <b>se realice con celeridad de forma eficaz y oportuna</b>, en coordinación con las diferentes entidades públicas a nivel nacional y con las representaciones diplomáticas y consulares del Estado Plurinacional de Bolivia en el exterior.',
      codigo: 'SGC-DOC-002'
    },
    vision: {
      title: 'VISIÓN',
      descripcion: 'Ser reconocida por brindar un servicio de calidad <b>(desburocratizado)</b> en Apostillado y Legalización de Firmas para los usuarios, mediante la <b>utilización eficiente de tecnologías de información y comunicación</b>, en el marco de la Normativa Boliviana e Internacional.',
      codigo: 'SGC-DOC-001'
    },
    valores: {
      title: 'VALORES',
      descripcion: 'Nos caracterizamos por trabajar con <b>RESPONSABILIDAD, PROFESIONALISMO, COLABORACIÓN, TRABAJO EN EQUIPO, TRANSPARENCIA Y CALIDEZ.</b>',
      codigo: 'SGC-DOC-001'
    }
  }
};



// WEBPACK FOOTER //
// ./src/lang/es/messages.js